export class NavigationInfo {
	title = $state<string>("");
	path = $state<string>("");

	constructor(title: string, path: string) {
		this.title = title;
		this.path = path;
	}
}
